exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.isMain[data-v-a139ea70] {\n  font-weight: bold;\n}\n[data-v-a139ea70] .v-list__tile{\n  height:32px;\n}\n[data-v-a139ea70] .v-list__tile p{\n  margin-bottom:0;\n}\n", ""]);

// exports
